import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installPushNavigation } from './utils/pushNavigation';

/**
 * ORION PWA ENGINE
 * Логика управления Service Worker:
 * 1. Включается в production-сборке (`react-scripts build` — только она
 *    и генерирует `service-worker.js`). Dev-сервер CRA воркер не собирает,
 *    поэтому офлайн-режим проверяется на локально собранном билде
 *    (например, `npx serve -s build`). Флаг REACT_APP_ENABLE_SW=true
 *    включает регистрацию вручную — для нестандартных окружений, где
 *    NODE_ENV не равен production, но воркер на месте.
 * 2. Автоматически перезагружает страницу при обнаружении нового билда на Jino.
 * 3. Исключает "прыжки" интерфейса за счет чистой регистрации.
 */
const swEnabled = process.env.NODE_ENV === 'production' || process.env.REACT_APP_ENABLE_SW === 'true';

const registerPWA = async () => {
    if (!swEnabled || !('serviceWorker' in navigator)) {
        return;
    }

    try {
        const reg = await navigator.serviceWorker.register('/service-worker.js');
       
        // Слушаем появление новой версии приложения
        reg.onupdatefound = () => {
            const worker = reg.installing;
            if (!worker) return;

            worker.onstatechange = () => {
                // Если новая версия скачана и готова заменить старую
                const isNewReady = worker.state === 'installed' && navigator.serviceWorker.controller;
                if (isNewReady) {
                    
                    window.location.reload();
                }
            };
        };
    } catch (err) {
        // В dev `service-worker.js` не существует (404) — это ожидаемо,
        // поэтому не пугаем себя ошибкой в консоли.
        console.warn('Orion PWA Error:', err);
    }
};

// Запускаем регистрацию при загрузке окна
window.addEventListener('load', registerPWA);

// Клик по push-уведомлению при уже открытом приложении: service worker
// присылает OPEN_CHAT, а приложение переиспользует событие OPEN_CHAT_EVENT
// (его слушает App.tsx и переходит в /dashboard/chat/<id>).
installPushNavigation();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
